module.exports = __webpack_public_path__ + "img/trash.02c474fd.svg";